import Vue from 'vue';
import VueTouch from 'vue-touch';

Vue.use(VueTouch);
